import React from 'react';
import { ResponsiveContextPropTypes } from './propTypes';
export var ResponsiveContext = /*#__PURE__*/React.createContext(undefined);
ResponsiveContext.propTypes = ResponsiveContextPropTypes;